import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PromotionType } from '../types/offers';
import type { RootState } from './index';

interface OffersReducerTypes {
  offersList: PromotionType[];
  filteredOffers: PromotionType[];
  isLoading: boolean;
  totalCount: number | null;
}

const initialState: OffersReducerTypes = {
  offersList: [],
  filteredOffers: [],
  isLoading: false,
  totalCount: null,
};

const offersSlice = createSlice({
  name: 'offersState',
  initialState,
  reducers: {
    setOffers: (state: OffersReducerTypes, action: PayloadAction<PromotionType[]>) => {
      return {
        ...state,
        offersList: action.payload,
      };
    },
    setFilteredOffers: (state: OffersReducerTypes, action: PayloadAction<PromotionType[]>) => {
      return { ...state, filteredOffers: action.payload };
    },
  },
});

export const selectOffers = (state: RootState) => state.offersState;

export const { setOffers, setFilteredOffers } = offersSlice.actions;

export default offersSlice.reducer;
